var $1a7b153345aecfe9$exports = {};
$1a7b153345aecfe9$exports = {
    "colorFormat": `V\xe4rvivorming`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$1a7b153345aecfe9$exports as default};
//# sourceMappingURL=et-EE.mjs.map
